import * as React from 'react';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import LoadingWithMessage from '../../../misc/components/LoadingWithMessage';
import { ConfigureVitaloJak2 } from './ConfigureVitaloJak2';
import { StudyScheduleVisit, StudyScheduleSession, Subject } from 'webportalclient';
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';
import { useAuth } from "react-oidc-context";

interface VitaloJak2ConfigureStateProps {
    subject: Subject;
    outstandingVisits: StudyScheduleVisit[];
    sessionScheduleItems: StudyScheduleSession[];
    device: Device;
}

interface VitaloJak2ConfigureDispatchProps {
    onError: (message: string) => void;
    onComplete: () => void;
}

export const VitaloJak2Configure = ({ subject, outstandingVisits, sessionScheduleItems, device, onError, onComplete }: VitaloJak2ConfigureStateProps & VitaloJak2ConfigureDispatchProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const { user } = useAuth();

    const configure = async () => {
        await ConfigureVitaloJak2(
            legacyClient,
            client.client,
            user?.profile.email,
            subject,
            outstandingVisits,
            sessionScheduleItems,
            device,
            onError,
            onComplete
        );
    }

    React.useEffect(() => {
        configure();
    }, []);


    return (
        <div className="modal-body">
            <LoadingWithMessage message="Configuring device. This may take some time. Please do not unplug the cable." />
        </div>
    );
}
